import { useState, useEffect } from 'react'
import { storage, firestore } from '../firebase'
import { timestamp } from '../firebase';

const useStorage = (file, type, userId, authorId) => {
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState("");
    const [url, setUrl] = useState("")

    useEffect(() => {

        const date = new Date().getTime()

        const storageRef = storage.ref(userId + "/gallery/" + date + "_" + file.name);
        const collectionRef = firestore.collection("authors").doc(authorId).collection("images");

        storageRef.put(file).on('state_changed', (snap) => {
            let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
            setProgress(percentage);
        }, (err) => {
            setError(err)
        }, async () => {
            const url = await storageRef.getDownloadURL();
            const createdAt = timestamp();
            collectionRef.add({ imageUrl: url, createdAt, type})
            setUrl(url)
        })

    }, [file])

    return {progress, url, error}

}

export default useStorage